import getKPI from './kpi';
import Speedometer from './Speedometer';

const Balance = ({ transactions }) => {
  const kpi = getKPI(transactions);

  return (
    <>
      <h4>Sold</h4>
      <div className="balance-container">
        <h1>{kpi.balance.toLocaleString('ro-RO')}</h1>
        <small className="currency">LEI</small>
      </div>
      <div className="chart-container">
        <Speedometer needleValue={kpi.needleValue} />
      </div>
      <div className="inc-exp-container">
        <div>
          <h4>Venituri</h4>
          <p className="money plus">{kpi.income.toLocaleString('ro-RO')}</p>
        </div>
        <div>
          <h4>Cheltuieli</h4>
          <p className="money minus">{kpi.expense.toLocaleString('ro-RO')}</p>
        </div>
      </div>
    </>
  );
};

export default Balance;
